import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { BehaviorSubject } from 'rxjs';
import { LoggerService } from './Non-Master/logger.service';
import { tConsultHeadModel, tConsultHeadModelWithPatientInfo, tConsultHeadModelWithPatientInfoV2, TotalCtTodayResponse } from '../models/tConsultHeadModel';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';




@Injectable({
    providedIn: 'root'
})

export class tWaitingConsultService {

    constructor(private http: HttpClient,
        private log: LoggerService,) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tConsultHeadModels';

    readonly pathNameOnConsult = '/onConsult';

    getTotalCtToday(patientID:string){
      return this.http.get<TotalCtTodayResponse>(this.baseurl + this.pathName + `/totalCtToday/${patientID}`);
    }

    getWaitingConsult(shopID: string, ArrDate: string) {
        // return this.http.get<tConsultHeadModelWithPatientInfo[]>(this.baseurl + this.pathName + '/GetWaitingConsult/' + shopID + '/' + ArrDate).pipe(shareReplay(1));
        return this.http.get<tConsultHeadModelWithPatientInfoV2[]>(this.baseurl + this.pathName + '/GetWaitingConsult/v2/' + shopID + '/' + ArrDate).pipe(shareReplay(1));
    }

    getOutStandingConsult(shopID: string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tConsultHeadModelWithPatientInfo[]>(this.baseurl + this.pathName + '/GetOutStandingWaitingConsult/' + shopID);
    }

    getOutStandingConsultHeader(shopID: string, billPayID: string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tConsultHeadModelWithPatientInfo>(this.baseurl + this.pathName + '/GetOutStandingConsultHeader/' + shopID + '/' + billPayID);
    }


    AssignBedNo(data: tConsultHeadModel) {
        // tslint:disable-next-line:max-line-length
        return this.http.put(this.baseurl + this.pathName + '/AssignBedNo/Formatted/' + data.shopID + '/' + data.clthConsultNumber, data);
    }

    LeaveBed(data: tConsultHeadModel) {
        // tslint:disable-next-line:max-line-length
        return this.http.put(this.baseurl + this.pathNameOnConsult + '/Formatted/LeaveBed/' + data.shopID + '/' + data.clthConsultNumber, data);
    }


    addData(data: tConsultHeadModel){
        return this.http.post(this.baseurl + this.pathName + '/' + 'Formatted', data);
    }


    updateRemark(data: tConsultHeadModel){
        return this.http.put(this.baseurl + this.pathName + '/Formatted/updateRemark/' + data.shopID + '/' + data.clthConsultNumber, data);
    }
}
